import { render } from "./HiddenField.vue?vue&type=template&id=f4dac348"
import script from "./HiddenField.vue?vue&type=script&lang=js"
export * from "./HiddenField.vue?vue&type=script&lang=js"

import exportComponent from "/home/omid_es327/Projects/erp/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HiddenField.vue"]])

export default __exports__